import { useQuery } from '@tanstack/react-query'

import { getInvoicingProvider } from '@flecto/api/shared'

export function useQueryGetInvoicingProvider() {
  return useQuery({
    queryKey: ['QueryGetInvoicingProvider'],
    queryFn: async () => {
      try {
        return await getInvoicingProvider()
      } catch (error: unknown) {
        if (
          (error as { response?: { status: number } })?.response?.status === 404
        ) {
          return {
            user_integration: {
              invoice: [],
            },
          }
        }
        throw error
      }
    },
    refetchOnWindowFocus: false,
    retry: (failureCount, error: unknown) => {
      if (
        (error as { response?: { status: number } })?.response?.status === 404
      ) {
        return false
      }
      return failureCount < 1
    },
  })
}
